export default __webpack_public_path__ + "static/media/JAM.fde45d84.svg";